import React from "react";
import ReactDOM from "react-dom";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { IOccupant } from "../../../types/ILocation";
import { useNitroStore } from "../../../store/Store";
import NitroService from "../../../utils/nitro.service";
import AddProductPanelContent from "./AddProductPanelContent";

const AddProductToOriginPanel: React.FC = () => {
  const [
    destinationToTroubleshoot,
    originToTroubleshoot,
    setDisplayAddProductToOriginPanel,
    setExpandedDestination,
  ] = useNitroCAStore((state) => [
    state.destinationToTroubleshoot,
    state.originToTroubleshoot,
    state.setDisplayAddProductToOriginPanel,
    state.setExpandedDestination,
  ]);
  const [product, setMultiLocationDestinations] = useNitroStore((state) => [
    state.product,
    state.setMultiLocationDestinations,
  ]);
  const triggerRefetchQuotes = useNitroCAStore(
    (state) => state.triggerRefetchQuotes,
  );
  const occupants = originToTroubleshoot.origin.details?.occupants || [];

  // close logic
  const close = () => {
    setDisplayAddProductToOriginPanel(false);
  };

  // submit logic
  const submit = async (selected: IOccupant[]) => {
    const updatedOccupants = occupants.map((occupant) => {
      if (selected.find((o) => o.id === occupant.id)) {
        return {
          ...occupant,
          products: [...occupant.products, { product, quantity: 0 }],
        } as IOccupant;
      }
      return occupant;
    });
    console.log(
      "Updating occupants for origin ID:",
      originToTroubleshoot.origin.id,
      "with occupants:",
      updatedOccupants,
    );
    await NitroService.updateOccupants({
      id: originToTroubleshoot.origin.id,
      occupants: updatedOccupants,
    });
    console.log(
      "Successfully updated occupants for origin ID:",
      originToTroubleshoot.origin.id,
    );
    // after successfully adding product, refetch multi-location data
    setMultiLocationDestinations([]);
    triggerRefetchQuotes();
    setExpandedDestination(
      {
        id: destinationToTroubleshoot.id,
        name: destinationToTroubleshoot.name,
      },
      {
        expandTruckWithNoFreight: true,
      },
    );
    close();
  };

  return ReactDOM.createPortal(
    <AddProductPanelContent
      occupants={occupants}
      pinType={originToTroubleshoot.isKoch ? "koch" : "competitor"}
      close={close}
      submit={submit}
    />,
    document.body,
  );
};

export default AddProductToOriginPanel;
